<template>
  <h3 :class="style({ lang })">
    <slot />
  </h3>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

import type { Lang } from '@/models/lang';

interface Props {
  lang?: Lang;
}

withDefaults(defineProps<Props>(), {
  lang: 'jp',
});

const style = tv({
  base: '',
  variants: {
    lang: {
      jp: 'text-sm font-light leading-6 tracking-[1.5px] md:text-base md:leading-8',
      en: 'font-Spectral text-base font-light leading-6 tracking-wide md:text-[22px] md:font-normal md:leading-[34px]',
    },
  },
});
</script>
